/**
 * Guards a post-auth redirect target against open-redirect attacks. Only a
 * same-origin relative path (starting with a single "/", never "//" or a
 * scheme) is considered safe to `navigate()` to.
 */
export function isSafeRedirect(path: string | null | undefined): path is string {
  if (!path) return false
  if (!path.startsWith('/')) return false
  if (path.startsWith('//')) return false
  if (path.includes('://')) return false
  return true
}
